import { I as t } from "../../constants-DeVuDy8J.js";
import { createElementBlock as r, openBlock as d, normalizeClass as l, createElementVNode as o } from "vue";
import { _ as n } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const s = {
  name: "DtIconCloudy",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(t).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return t[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, c = ["aria-label", "data-qa", "aria-hidden"], _ = /* @__PURE__ */ o("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M7.163 4.015a4 4 0 0 0-3.319-.96 2.25 2.25 0 0 1 4.072.582.5.5 0 0 0 .48.363H9.5a1 1 0 0 1 1 1 .5.5 0 0 0 1 0 2 2 0 0 0-2-2h-.75a3.251 3.251 0 0 0-6.159.485A4 4 0 0 0 4.5 11h4.25a2.75 2.75 0 1 0 0-5.5h-.541a4 4 0 0 0-1.046-1.485Zm-2.138.031A3 3 0 1 0 4.5 10h4.25a1.75 1.75 0 1 0 0-3.5h-.895a.5.5 0 0 1-.48-.357 3 3 0 0 0-2.35-2.097Z",
  fill: "currentColor"
}, null, -1), u = [
  _
];
function m(e, h, i, f, p, a) {
  return d(), r("svg", {
    "aria-label": i.ariaLabel,
    class: l([a.iconSizeClass, "d-icon d-icon--cloudy"]),
    "data-qa": a.dataQA,
    "aria-hidden": a.ariaHidden,
    role: "img",
    "data-name": "Cloudy",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, u, 10, c);
}
const C = /* @__PURE__ */ n(s, [["render", m]]);
export {
  C as default
};
//# sourceMappingURL=cloudy.js.map
